export enum CommandOrchestrationActionMode {
    EXECUTING, NONE, FINISHED
}
